import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { TGoogleIntegrationType } from '~/types/server.types';

export class NylasAdapter extends BaseHttpAdapter {
    getNylasEmailProvider(
        emailAddress: string,
        integrationType: TGoogleIntegrationType
    ) {
        return this.apiService.apiRequest<{
            provider_name: string;
            is_imap: string;
            auth_name: string;
            detected: string;
        }>({
            method: 'post',
            url: `/api/v2/nylas_email_provider`,
            data: {
                email_address: emailAddress,
                integration_type: integrationType
            }
        });
    }
}
